import { NgModule } from '@angular/core';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LayoutsComponent } from './layouts/layouts.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    LayoutsComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent
  ],

  imports: [
    RouterModule,
    NgbDropdownModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [ HeaderComponent, LayoutsComponent, FooterComponent,SidebarComponent, RouterModule],
  providers: [],
})
export class SharedModule { }
